import { Outlet } from "react-router-dom";

const Entertainment = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Entertainment;
